// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23.8348 8.49981L11.9999 0.807129L0.165039 8.49981L11.9999 16.1925L19.9999 10.9925V15.9998H21.9999V9.6925L23.8348 8.49981Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M5 17.4997V13.835L11.9999 18.385L19 13.835V17.4997C19 18.9695 17.986 20.1153 16.7465 20.8384C15.4825 21.5757 13.8021 21.9997 12 21.9997C10.1979 21.9997 8.51754 21.5757 7.25349 20.8384C6.01399 20.1153 5 18.9695 5 17.4997Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-education-filled')
export default class EducationFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'education-filled',
    }
  }
}
